import { h } from 'vue'
export default{
    props:{
        dialog:Object//Zdialog的组件
    },
    render(){
        let dialog=this.dialog;
        let {component,props,events={}}=dialog;
        let listeners={};
        for(let key in events){
            if(key.startsWith("on")){
                listeners[key]=events[key]
            }else{
                let name=key.substring(0, 1).toUpperCase() + key.substring(1)
                listeners['on'+name]=events[key]
            }
        }
        return h(component,Object.assign({},props,listeners));
    }
}